import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import {CertificadosObservacoesModel} from "./certificados-observacoes.model";
import {CertificadosObservacoesService} from './certificados-observacoes.service';
import {Funcoes} from "../funcoes";
import {Global} from "../global";


@Component({
  selector: 'app-observacoes-form',
  templateUrl: './certificados-observacoes-form.component.html'
})
export class CertificadosObservacoesFormComponent implements OnInit {

  enviandoForm = false;
  form: FormGroup;
  title: string;
  observacao: CertificadosObservacoesModel = new CertificadosObservacoesModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private observacoesService: CertificadosObservacoesService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id_observacao: [],
      nome: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      observacao: ['', [
        Validators.required
      ]],
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    var id = this.route.params.subscribe(params => {
      var id = params['id_observacao'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.editarObservacao');
      }else{
        this.title = id ? this.func.traduzir('front.visualizarObservacao') : this.func.traduzir('front.cadastrarNovaObservacao');
      }

      if (!id) {
        return;
      }

      this.observacoesService.getById(id)
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.title = this.func.traduzir('front.editarObservacao')+': '+json.Payload[0].nome;
            }else{
              this.title = this.func.traduzir('front.visualizarObservacao') + ': ' + json.Payload[0].nome;
            }
            this.observacao = json.Payload[0];

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    let result,
      values = this.form.value;

    this.enviandoForm = true;

    if (values.id_observacao) {
      result = this.observacoesService.editar(values, values.id_observacao);
    } else {
      result = this.observacoesService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'certificados-observacoes']),
      error => {
        let json = error.json();
        this.func.showErro(json);

        this.enviandoForm = false;

        for(let i in json.Message.ErrorInput){
          let erro = {};
          erro[i] = json.Message.ErrorInput[i];
          this.form.controls[i].setErrors(erro);
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/certificados_observacoes/certificados-observacoes-form.component.ts